// removed by extract-text-webpack-plugin
module.exports = {"root":"_2EcHXf2FKid1vXLd-9u27-","titleText":"_1q97fIuyXjYSpFe_oskVL0","logoContainer":"_1Ans62SmbwUZ-Gxd2S3JS","logo":"_1cWZnKJb--g0lJngqu9k2t","paperContainer":"_2bdx0LIKkja2P0EQApCqv_","buttonsContainer":"_2dr3FPRgdIgROTvLgQpLDd","msgText":"_2Ivj1JWnQLKLt875Em1ebC","detailTextMini":"LSBDNeWBv0_20sgCY6Ktw"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Misc/NotFound/styles.css
// module id = 2591
// module chunks = 0